import { render, staticRenderFns } from "./ButtonDayComponent.vue?vue&type=template&id=4e586af1"
import script from "./ButtonDayComponent.vue?vue&type=script&lang=js"
export * from "./ButtonDayComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports